export const CONTACT = {
  email:   'contact@biltzentech.com',
  phone:   '+91 97407 36690',
  phoneTel: '+919740736690',
  address: 'Bengaluru, India (Remote-first)',
};

export const COMPANY = {
  name:    'BiltzenTech',
  tagline: 'AI-Powered Engineering Solutions',
};
